import React from "react";
import ElencoLavorazioniProdotto from "../ElencoLavorazioniProdotto";

function Lavorazioni({ prodottoTemp, appuntiProdottoValue, handleChangeAppProd, inputClasses, utente }) {


    return (
        <div>
            <p>Appunti lavorazione</p>
            <textarea type="text" rows="6" cols="50" id="appunti" name="appunti" value={appuntiProdottoValue} onChange={handleChangeAppProd} className={inputClasses}></textarea><br />
            <h3>Lavorazioni precedenti</h3>
            {prodottoTemp.lavorazioni.map((idLav, i) => (<ElencoLavorazioniProdotto key={i} idLavorazione={idLav} utente={utente} />))}
        </div>
    )



}

export default Lavorazioni;